module.exports = __webpack_public_path__ + "img/3.c8b44497.png";